import { render } from "./agence.vue?vue&type=template&id=0b280b7a&scoped=true"
import script from "./agence.vue?vue&type=script&lang=js"
export * from "./agence.vue?vue&type=script&lang=js"

import "./agence.vue?vue&type=style&index=0&id=0b280b7a&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b280b7a"]])

export default __exports__